import { GQL_QUERIES } from 'src/utils/analytics/newrelic/ErrorTracker';
import { graphQlRequest } from '../GraphQL/RequestHandler';
import { LIVE_MATCH } from '../GraphQL/Queries/liveMatchQuery';

export const getLiveMatch = async () => {
  const requestParams = {
    tournamentSeasonId: `${process.env.NEXT_PUBLIC_ILT_TOURNAMENT_ID}:${process.env.NEXT_PUBLIC_ILT_SEASON_ID}`
  };

  try {
    const response = await graphQlRequest(
      LIVE_MATCH,
      requestParams,
      GQL_QUERIES.LIVE_MATCH_QUERY
    );
    return response?.resolveEvent || {};
  } catch (error) {
    console.error('Error while fetching live match query: ', error);
    return null;
  }
};
